import { Flex, Icon, Text } from '@chakra-ui/react';
import Link from 'next/link';
import { LuArrowRight } from 'react-icons/lu';

import { useSidebarNavigationEntities } from 'hooks/useNavigationEntities';

const hoverStyle = { bg: { base: 'gray.50', _dark: 'gray.800' } };

// Placeholder figures keyed by home-item id; shown only when an item is present.
const DETAIL_BY_ID: Record<string, string> = {
  hedges: 'GHS100,000',
  predictions: 'GHS10,000',
};

const RedirectionLink = ({
  href,
  icon,
  label,
  detail,
}: {
  href: string;
  icon: React.ReactNode;
  label: string;
  detail?: string;
}) => (
  <Link href={href}>
    <Flex
      justify="space-between"
      align="center"
      p={2}
      _hover={hoverStyle}
      borderRadius="md"
      cursor="pointer"
    >
      <Flex align="center" gap={2}>
        {icon}
        <Text>{label}</Text>
      </Flex>
      <Flex align="center" gap={2}>
        {detail != null && (
          <Text fontSize="sm" fontWeight="medium">
            {detail}
          </Text>
        )}
        <Icon as={LuArrowRight} />
      </Flex>
    </Flex>
  </Link>
);

// Home redirections mirror the active mode's Home sub-items, so the home page
// and the sidebar stay in lockstep (e.g. Supplier only sees "My supply commitments").
const Redirections = () => {
  const { byId } = useSidebarNavigationEntities();
  const homeChildren = byId.positions?.children ?? [];

  return (
    <Flex direction="column" gap={4}>
      {homeChildren.map((child) => {
        const href = byId[child.id]?.absolutePath;
        if (href == null) {
          return null;
        }
        return (
          <RedirectionLink
            key={child.id}
            href={href}
            icon={child.icon}
            label={child.name}
            detail={DETAIL_BY_ID[child.id]}
          />
        );
      })}
    </Flex>
  );
};

export default Redirections;
